'use client';

import React, { useState } from 'react';
import { IdView } from '../../../../components';
import { RevshareCampaign, CampaignEditData } from '../types';
import { Icon } from '@iconify/react';
import EditCampaignModal from './EditCampaignModal';

interface IdCellProps {
  campaign: RevshareCampaign;
  onEditCampaign?: (campaign: RevshareCampaign, data: CampaignEditData) => void;
  onRefresh?: () => void;
}

const IdCell: React.FC<IdCellProps> = ({ campaign, onEditCampaign, onRefresh }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // Use track_link_id or _id as the campaign identifier
  const idString = campaign._id || '';

  const handleSaveCampaign = (data: CampaignEditData) => {
    if (onEditCampaign) {
      onEditCampaign(campaign, data);
    }
    setIsEditModalOpen(false);
  };

  return (
    <div className="flex items-center gap-2 py-2">
      <IdView textToCopy={idString}>{idString.slice(-4)}</IdView>
      <button
        onClick={() => setIsEditModalOpen(true)}
        className="flex items-center justify-center hover:opacity-70 transition-opacity"
        title="Редактировать кампанию"
      >
        <Icon icon="solar:settings-linear" width={16} height={16} className="text-partner" />
      </button>

      <EditCampaignModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        campaign={campaign}
        onSave={handleSaveCampaign}
        onSuccess={onRefresh}
      />
    </div>
  );
};

export default IdCell;
